import { render, staticRenderFns } from "./CurrentUrlManage.vue?vue&type=template&id=4058bb34&scoped=true"
import script from "./CurrentUrlManage.vue?vue&type=script&lang=js"
export * from "./CurrentUrlManage.vue?vue&type=script&lang=js"
import style0 from "./CurrentUrlManage.vue?vue&type=style&index=0&id=4058bb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4058bb34",
  null
  
)

export default component.exports